import { useMemo } from 'react';
export const usePromptTemplateParameters = template => {
  return useMemo(() => {
    if (!template) {
      return [];
    }
    const parameters = [];
    template.prompt.forEach(promptSection => promptSection.inputs.forEach(input => {
      parameters.push(input);
    }));
    return parameters;
  }, [template]);
};